import { State } from "./types";

export interface ToggleBorderExplicitnessAction {
  type: "TOGGLE BORDER EXPLICITNESS";
}

export const toggleBorderExplicitness = (
  state: State,
  action: ToggleBorderExplicitnessAction,
): State => {
  let newCells = state.cells
    .map(c => {
      switch (c.selectedBorder) {
        case "bottom":
          return {
            ...c,
            bottomBorderImplicit : !c.bottomBorderImplicit
          }
        case "top":
          return {
            ...c,
            topBorderImplicit : !c.topBorderImplicit
          }
        case "left":
          return {
            ...c,
            leftBorderImplicit : !c.leftBorderImplicit
          }
        case "right":
          return {
            ...c,
            rightBorderImplicit : !c.rightBorderImplicit
          }
        default : return c;
      }
    })

    return {
      ...state,
      cells:newCells
    }
  }

